<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
  >
    <v-card>
      <v-card-title>
        <span class="text-h6">Confirmação</span>
      </v-card-title>
      <v-card-text class="text-subtitle-2" v-text="configs.reorder_message" />

      <v-card-actions>
        <v-btn
            color="darken-1"
            text
            @click="$emit('close')"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="primary px-6"
            depressed
            @click="$emit('confirm')"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "DialogConfirmationReorder",
  props: ['dialog'],
  setup () {
    const configs = _config.functionalities.digitalmenu.configs
    return { configs }
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>

</style>